<template>
  <div v-loading="loading">
    <section v-if="error == 0 && label.length > 0">
      <el-table class="w100 tx-c my-table" :data="data" stripe border :row-class-name="hasBold" :empty-text="getId == 'DB' ? '暂无待办记录' : '暂无已办记录'" height="600px" @row-click="clickRowItem">
        <el-table-column v-for="(item, index) in label" :key="index" :label="item.label" resizable align="center">
          <template slot-scope="scope">
            <span :class="scope.row[item.key] == '紧急' || scope.row[item.key] == '已超时' ? 'red' : null">{{ scope.row[item.key] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="60">
          <template slot-scope="scope">
            <span class="blue cu-p" v-if="hasUrl == ''" @click.stop="clickRow(scope.row, 'aws')">查看</span>
            <a class="blue cu-p" v-else :href="scope.row.taskUrl" target="_blank">查看</a>
            <!-- <a class="blue cu-p" :href="scope.row.taskUrl" target="_blank">查看</a> -->
            <!-- <span class="ml10 orange cu-p" v-if="hasUrl == ''" @click="clickRow(scope.row, 'lc')">流程跟踪</span> -->
          </template>
        </el-table-column>
      </el-table>

      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </section>

    <a class="none" ref="href" :href="hasUrl" target="_blank"></a>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ServerInfoTab",
  props: {
    getId: String,
    getUrl: String,
    processDefId: String,
    getId: String,
    hasUrl: String
  },
  data() {
    return {
      loading: false,
      error: 0,
      page: 1,
      size: 30,
      total: 0,
      label: [],
      data: []
    };
  },
  computed: {
    ...mapState(["userToken", "userData"])
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;

      this.$http
        .post(
          this.getUrl,
          this.$qs.stringify({
            // target: this.userData.userId,
            pageNum: this.page,
            pageSize: this.size,
            processDefId: this.processDefId
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.RetStatus == 0 && data.RetCode) {
            this.label = data.RetData.label;
            this.total = data.RetData.total;
            this.data = data.RetData.data;
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.error = 404;

          this.loading = false;
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchData();
    },
    changePage(value) {
      this.page = value;
      this.fetchData();
    },
    hasBold({ row }) {
      // console.log(row);
      if (row.readState == 0) {
        return "bold cu-p";
      }
      return "cu-p";
    },
    clickRowItem(row) {
      // console.log(row);
      if (this.hasUrl != "") {
        this.$refs.href.click();
      } else {
        this.clickRow(row, "aws");
      }
    },
    clickRow(row, type) {
      if (row.taskUrl && row.taskUrl != "" && type == "aws") {
        this.$emit("show-aws", row.taskUrl);
      } else if (type == "lc" && row.id != "") {
        this.$emit(
          "show-aws",
          `/hall/aws/portal/r/w?sid=${this.userToken}&cmd=CLIENT_BPM_FORM_TRACK_OPEN&processInstId=${row.id}&supportCanvas=true`
        );
      }
    }
  }
};
</script>

<style>
</style>
